import {TextSharedQuestion} from "./TextSharedQuestion";

export class EmailSharedQuestion extends TextSharedQuestion {

    isValid():boolean {
        super.isValid();

        return this.value && angular.isString(this.value.value) && this.value.value.indexOf('@') > -1 && this.value.value.length > 2;
    }

    validationMessage() : string {
        var message = this.getMessage('required');
        if (message) {
            return message;
        }

        return 'email_validation_message';
    }

}